var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"speech-bubble",class:{success: this.variant === 'success', warning: this.variant === 'warning'}},[_vm._t("default"),(_vm.author)?_c('span',{staticClass:"username"},[_vm._v(_vm._s(_vm.author))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }